const vestList = () => import('@/pages/community/vest/index.vue');
const vestForm = () => import('@/pages/community/vest/form.vue');

export default [{
    path: '/community/vest',
    component: vestList,
    meta: [{
        name: '社区管理'
    },
    {
        name: '马甲号列表',
        activeRoute: '/community/vest'
    }]
}, {
    path: '/community/vest/form',
    component: vestForm,
    meta: [{
        name: '社区管理'
    }, {
        name: '马甲号列表',
        url: '/community/vest'
    }, {
        name: '新增/编辑',
        activeRoute: '/community/vest'
    }]
}];